import { createFeatureSelector, createSelector } from '@ngrx/store';

import { SurveyState } from './survey.reducers';

// tslint:disable: max-line-length
export const surveysFeatureStateSelector = createFeatureSelector<SurveyState>('survey');

export const selectSurveys = createSelector(surveysFeatureStateSelector, (state: SurveyState) => state.surveys);
export const selectSurveysTotalCount = createSelector(surveysFeatureStateSelector, (state: SurveyState) => state.surveysTotalCount);

export const selectSurvey = createSelector(surveysFeatureStateSelector, (state: SurveyState) => state.survey);
